import { RootState } from "../../../../../store";
import { schedulesStateSelector } from "../../../../../schedules/selectors/schedulesStateSelector";

export const previewSelectedResourceIdsSelector = (state: RootState) => {
  const schedule = schedulesStateSelector(state);

  return schedule.previewSelectedResources;
};
